var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.editQuantity }, [
    !_vm.disabled
      ? _c(
          "button",
          {
            class: _vm.$style.editQuantityBtn,
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.decrease($event)
              }
            }
          },
          [
            _c("svg", {
              directives: [{ name: "svg", rawName: "v-svg" }],
              class: _vm.$style.editQuantityIcon,
              attrs: { symbol: "minus-sign" }
            })
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.quantity))]),
    _vm._v(" "),
    !_vm.disabled
      ? _c(
          "button",
          {
            class: _vm.$style.editQuantityBtn,
            attrs: { disabled: _vm.increaseDisabled },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.increase($event)
              }
            }
          },
          [
            _c("svg", {
              directives: [{ name: "svg", rawName: "v-svg" }],
              class: _vm.$style.editQuantityIcon,
              attrs: { symbol: "plus-sign" }
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/QuantityPicker.vue?vue&type=template&id=4c81eea9&
// module id = null
// module chunks = 